import { Component, EventEmitter, OnInit, Output, ViewChild, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { Grid as InavistaGrid, GridActionIconClickEvent, GridConfig } from '@inavista/components/grid';
import { RemoteSearchGridApi, provideRemoteSearchGrid, remoteSearchRow } from 'projects/service/src/app/shared/utils/remote-search-grid-api';
import { environment } from 'projects/service/src/environments/environment';
import { PROCEED_ACTION, PROCEED_ACTION_ICONS } from 'projects/service/src/app/shared/components/resource-selection-popup/resource-selection.grid.config';
import {
  CYCLE_COUNT_RESOURCE_SELECTION_COLUMNS, CYCLE_COUNT_RESOURCE_SELECTION_URL, buildCycleCountResourceSelectionGridConfig,
} from './cycle-counts-resource-selection.grid.config';

const BASE_URL = environment.apiUrl;
// The old grid's content was window.innerHeight - 350 tall, with its toolbar and header above it and the
// "Total Records" bar below. The inavista grid draws all of that inside its own box.
const GRID_CHROME_PX = 124;

@Component({
    selector: 'app-cycle-counts-resource-selection-popup',
    templateUrl: './cycle-counts-resource-selection-popup.component.html',
    styles: [],
    // The grid reads the old endpoint through RemoteSearchGridApi (same request, same response).
    providers: [...provideRemoteSearchGrid()],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CycleCountsResourceSelectionPopupComponent implements OnInit {

  isExpanded: boolean = false;
  gridConfig: GridConfig = null;
  readonly actionIcons = PROCEED_ACTION_ICONS;
  gridHeight: number = window.innerHeight - 350 + GRID_CHROME_PX;

  @ViewChild('resourceGrid') resourceGrid: InavistaGrid;

  @Input() employeeId: string;

  @Output() onClose = new EventEmitter();
  private readonly gridApi = inject(RemoteSearchGridApi);

  ngOnInit(): void {
    // POST pickers-scope/employee-search (ServiceEmployee/GetEmployeeSearchView's request and answer, on the person's tech
    // scope): everyone but the current employee. The old Query's fromResourceSelectionPopup flag made the CustomAdaptor
    // send employeeId with 'notequal' and drop the flag.
    this.gridApi.set(CYCLE_COUNT_RESOURCE_SELECTION_URL, {
      endpoint: `${BASE_URL}pickers-scope/employee-search`,
      columns: CYCLE_COUNT_RESOURCE_SELECTION_COLUMNS,
      searchFields: CYCLE_COUNT_RESOURCE_SELECTION_COLUMNS.map(([c]) => c),
      parameters: [{ key: 'employeeId', value: this.employeeId, oprtr: 'notequal' }],
    });
    this.gridConfig = buildCycleCountResourceSelectionGridConfig();
  }

  close() {
    this.onClose.emit();
  }

  onActionIconClick(event: GridActionIconClickEvent) {
    if (event.iconKey === PROCEED_ACTION) {
      const rowData: any = remoteSearchRow(event.row);
      rowData.technicianId = rowData.employeeId;
      rowData.technicianName = rowData.employeeName;
      this.onClose.emit(rowData);
    }
  }

}
